export const LetterTypeEnum = {
  Notification: 0,
  DirectCertification: 1,
};

export const LetterStringTypesEnum = {
  Notification: 'N',
  DirectCertification: 'D',
};



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/helpers/LetterTypeEnum.js